export const convert_date = (dt: string) => {
  const d = new Date(dt);

  const date_string = d.toISOString().slice(0, 10);

  return date_string
}

export const convert_datetime = (dt: string) => {
  const d = new Date(dt);

  const datetime_string = d.toLocaleDateString('ja-JP') + " " + d.toLocaleTimeString('ja-JP',{hour12: false, hour: '2-digit', minute:'2-digit'});

  return datetime_string
}

export const convert_elapsed_datetime = (dt: string) => {

  const month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const from = new Date(dt);

  const diff = new Date().getTime() - from.getTime();
  const elapsed = new Date(diff);

  if (elapsed.getUTCFullYear() - 1970) {
    return month_names[from.getUTCMonth()]  + ' ' + from.getUTCDate() + ', ' + from.getUTCFullYear();
  } else if (elapsed.getUTCMonth()) {
    return month_names[from.getUTCMonth()]  + ' ' + from.getUTCDate();
  } else if (elapsed.getUTCDate() - 1) {
    return elapsed.getUTCDate() - 1 + 'd ago';
  } else if (elapsed.getUTCHours()) {
    return elapsed.getUTCHours() + 'h ago';
  } else if (elapsed.getUTCMinutes()) {
    return elapsed.getUTCMinutes() + 'm ago';
  } else if (elapsed.getUTCSeconds()) {
    return elapsed.getUTCSeconds() + 's ago';
  } else {
    return 'now';
  }
}

export const convert_left_datetime = (dt:string) => {
  const from = new Date(dt);

  const diff = from.getTime() - new Date().getTime();
  let left: any = new Date(diff);

  const days = Math.floor(left/(1000*60*60*24))
  left = left - days*(1000*60*60*24)

  if (days>=1){return days+'Days '+left.getUTCHours()+':'+left.getUTCMinutes()+':'+left.getUTCSeconds()}
  else{return left.getUTCHours()+':'+left.getUTCMinutes()+':'+left.getUTCSeconds()}
}
